module.exports = __webpack_public_path__ + "assets/img/burger-menu-open.94e8d9ad.svg";